module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hide),
      expression: "!hide"
    }],
    staticClass: "ui small message",
    class: {
      'info': _vm.info, 'warning': _vm.warning, 'success': _vm.success, 'error': _vm.error
    }
  }, [_c('i', {
    staticClass: "icon big",
    class: [_vm.icon]
  }), _c('span', [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df29a15e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 463
// module chunks = 28